@import (reference) 'ui-components/components/button/button-text.module.less';
@import (reference) '../../../../constants/spacing.module.less';

.status-pill {
  border-style: solid;
  border-width: 1px 1px 1px 8px;
  border-radius: 1px;
  color: var(--default--text-color--17);
}

.neutral-pill {
  .status-pill();
  background-color: var(--default--background-color--13);
  border-color: var(--default--border-color--14);
}

.success-pill {
  .status-pill();
  background-color: var(--success--background-color--4);
  border-color: var(--success--border-color--1);
}

.error-pill {
  .status-pill();
  background-color: var(--error--message--background-color--1);
  border-color: var(--error--message--border-color--1);
}

.table-cell-button {
  .button-text();
  height: auto;
  min-height: 24px;
  padding: @space-4 @space-12;
}

.loading-indicator {
  height: 24px;
  width: 24px;
}

.actions-cell {
  justify-content: center;
}

.header-with-tooltip {
  align-items: center;
  gap: @space-8;
}

.info-icon {
  display: flex;
  place-items: center center;
}
